import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 18l.01 0","key":"svg-0"}],["path",{"d":"M9.172 15.172a4 4 0 0 1 5.656 0","key":"svg-1"}]]

const IconWifi1 = createReactComponent('outline', 'wifi-1', 'Wifi1', __iconNode);

export default IconWifi1;